import { ArrowRight, BarChart3, CheckCheck, FileText } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

const AREAS = [
  { title: 'Reports', icon: FileText, text: 'Capture and review frontline observations, audit findings, hazards, near misses and other configured issues.' },
  { title: 'Actions', icon: CheckCheck, text: 'Assign owners, deadlines, priority and follow-up requirements.' },
  { title: 'Analytics', icon: BarChart3, text: 'Identify patterns across report type, site, time period, action status and other configured information.' },
];

const LOOP = ['Report', 'Review', 'Action', 'Evidence', 'Closure', 'Learning'];

// Section 7 — reports, actions and analytics: closing the loop.
export const ForeseeOutcomes = () => (
  <section aria-labelledby="foresee-outcomes-heading" data-testid="foresee-outcomes" className="bg-navy-900 py-20 sm:py-28 relative overflow-hidden">
    <div className="grain-overlay" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="07"
        eyebrow="Outcomes"
        title="Move from recording activity to managing outcomes"
        dark
        testid="foresee-outcomes-header"
      />
      <ul className="mt-14 grid gap-5 md:grid-cols-3">
        {AREAS.map((area, i) => (
          <Reveal key={area.title} delay={i * 0.08} className="h-full">
            <li className="flex h-full flex-col rounded-xl border border-white/10 bg-white/5 p-6" data-testid={`foresee-outcome-${area.title.toLowerCase()}`}>
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-gold-500 text-navy-950">
                <area.icon className="h-5 w-5" aria-hidden="true" />
              </span>
              <h3 className="mt-4 text-lg font-extrabold tracking-tight text-white">{area.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-300">{area.text}</p>
            </li>
          </Reveal>
        ))}
      </ul>
      <Reveal delay={0.15}>
        <ol className="mt-12 flex flex-wrap items-center justify-center gap-x-3 gap-y-2" aria-label="The closing loop" data-testid="foresee-loop">
          {LOOP.map((stage, i) => (
            <li key={stage} className="flex items-center gap-3">
              <span className="rounded-full border border-gold-500/40 bg-gold-500/10 px-3.5 py-1.5 text-xs font-bold text-gold-500">
                {stage}
              </span>
              {i < LOOP.length - 1 && <ArrowRight className="h-3.5 w-3.5 text-slate-500" aria-hidden="true" />}
            </li>
          ))}
        </ol>
        <p className="mt-5 text-center text-sm text-slate-400">
          The value lies in closing the loop — every report can be traced through to evidence, closure and learning.
        </p>
      </Reveal>
    </div>
  </section>
);
